var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerchandising(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Finance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Finance_Initial-(Desktop)",
    transform: "translate(-875.000000, -501.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(845.000000, 297.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transactions_Merchandising",
    transform: "translate(30.000000, 204.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    stroke: "transparent",
    mask: "url(#mask-2)",
    strokeWidth: 1.6,
    strokeDasharray: "0,0",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Tshirt_1407516",
    opacity: 0.699999988,
    transform: "translate(5.000000, 7.000000)",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.40374909,6.47189747 L4.32704309,5.85991609 C4.49586554,5.82548519 4.66135597,5.93322057 4.69689753,6.1031537 C4.70134023,6.1242565 4.70356158,6.14535931 4.70356158,6.16646212 L4.70356158,15.5649856 L15.3671428,15.5649856 L15.3671428,6.16646212 C15.3671428,5.99319697 15.5070877,5.85325205 15.6803528,5.85325205 C15.7114517,5.85325205 15.7414399,5.85658407 15.7692068,5.86546946 L18.6680659,6.47189747 L19.3955574,3.11432993 L13.4556728,0.763033047 C13.3534908,1.52606609 12.9958538,2.21246263 12.4705049,2.73336874 C11.8451955,3.35423552 10.9833124,3.7396394 10.0359075,3.7396394 C9.08850258,3.7396394 8.22550887,3.35423552 7.6001994,2.73336874 C7.07485059,2.21246263 6.71721356,1.52606609 6.61614223,0.763033047 L0.676257609,3.11432993 L1.40374909,6.47189747 L1.40374909,6.47189747 Z M6.96711522,0.00777471809 C7.993378,0.188814582 9.01741944,0.276557829 10.0359075,0.275447155 C11.0555063,0.274336481 12.078437,0.184371886 13.1058105,0.00777471809 C13.1635655,-0.00555337006 13.2268739,-0.00111067401 13.2868503,0.0222134802 L19.8731472,2.62896539 C20.0130922,2.68449909 20.0963927,2.83444008 20.0641832,2.98660242 L19.2145175,6.90839236 C19.1778653,7.07610413 19.0123749,7.18272884 18.8446631,7.14829794 L15.9946736,6.551866 L15.9946736,15.8793064 C15.9946736,16.0525715 15.853618,16.1925164 15.6803528,16.1925164 L4.39035151,16.1925164 C4.21708636,16.1925164 4.07714143,16.0525715 4.07714143,15.8793064 L4.07714143,6.551866 L1.22937327,7.14829794 C1.06055082,7.18495019 0.892839041,7.07721481 0.857297473,6.90839236 L0.00985320155,2.99770916 C-0.0290203889,2.84665749 0.049837466,2.68783111 0.198667784,2.62896539 L6.77052591,0.0277668503 C6.81051018,0.00999606611 6.85382647,0 6.8993641,0 C6.92268825,0 6.94601241,0.00222134802 6.96711522,0.00777471809 Z M12.8325847,0.685285866 C11.9029505,0.827452139 10.971095,0.89964595 10.0359075,0.900756624 C9.10071999,0.901867298 8.16775382,0.830784161 7.23811967,0.687507214 C7.3225309,1.30837399 7.61463816,1.86704301 8.04113699,2.29020981 C8.55204703,2.79778784 9.2584357,3.11321926 10.0359075,3.11321926 C10.8122686,3.11321926 11.5186573,2.79778784 12.0295674,2.29020981 C12.4571769,1.86704301 12.7492841,1.30726331 12.8325847,0.685285866 L12.8325847,0.685285866 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchandising);
export default __webpack_public_path__ + "static/media/merchandising.e03be66eabd30ce6280485c6dfbbd35d.svg";
export { ForwardRef as ReactComponent };